export const ids = {
  about: 'about',
  contact: 'contact',
  portfolio: 'portfolio',
  skills: 'skills',
  welcome: 'welcome',
}
